/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export default {
  Auths: 'المصادقة|المصادقة',
  SideMenus: 'القائمة الجانبية|القائمة الجانبية',
  Ages: '{0}-|[1]سنة|[2]سنتان|[3,10]:age سنوات|[11,*] :age سنة',
  Days: '{0}-|[1]يوم|[2]يومان|[3,10]:days أيام|[11,*]:days يوم',
  Minutes: '{0}-|[1]دقيقة|[2]دقيقتان|[3,10]:minutes دقائق|[11,*] :minutes دقيقة',
  Hours: '{0}-|[1] ساعة|[2] ساعتان|[3,10]:hours ساعات|[11,*]:hours ساعة',
  Months: '{0}-|[1] شهر واحد|[2] شهرين|[3,10]:months أشهر|[11,*]:months شهر',
  Profiles: 'الملف الشخصي|الملف الشخصي',
  Avatars: 'الشعار|الشعار',
  MediaFiles: 'المرفق|المرفقات',
  Attachments: 'المرفق|المرفقات',
  Signatures: 'التوقيع|التواقيع',
  Permissions: 'الصلاحية|الصلاحيات',
  Roles: 'الوظيفة|الوظائف',
  Users: 'المستخدم|المستخدمون',
  Sales: 'الإيراد|الإيرادات',
  Expenses: 'الصرف|المصروفات',
  Utilities: 'أداة|أدوات',
  Notifications: 'الإشعار|الإشعارات',
  Settings: 'الإعداد|الإعدادات',
  Countries: 'الدولة|الدول',
  Cities: 'المدينة|المدن',
  Companies: 'الشركة|الشركات',
  Orders: 'الطلب|الطلبات',
  OrderStatuses: 'حالة الطلب|حالات الطلب',
  Categories: 'القسم|الأقسام',
  Offers: 'العرض|العروض',
  OrderCategories: 'تصنيف الطلب|تصنيفات الطلبات',
  AttributeLogs: 'سجل التعديلات|سجلات التعديلات',
  AttributesLogs: 'سجل التعديلات|سجلات التعديلات',
  AttachmentTypes: 'نوع المرفق|أنواع المرفقات',
  JobPositions: 'جهة العمل|جهات العمل',
  Banks: 'البنك|البنوك',
  ServiceTypes: 'الخدمة المقدمة|الخدمات المقدمة'
}
